module.exports = __webpack_public_path__ + "gamecode/img/zljslg_favicon.png?8410ba84";